import React, {
  useEffect,
} from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useToast,
} from "@chakra-ui/react";
import {
  useDispatch,
  useSelector,
} from "react-redux";
import {
  Link as RouterLink,
  useNavigate,
} from "react-router-dom";

import {
  logout,
} from "../redux/auth/authActions";
import {
  fetchUserProfile,
} from "./profile/profileAction";

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();

  const { user, loading } = useSelector(
    (state) => state.auth
  );

  const profile = useSelector(
    (state) => state.profile?.profile
  );
  const isAdmin =
  profile?.isAdmin === true ||
  user?.isAdmin === true;

  useEffect(() => {
    if (user?.uid) {
      dispatch(
        fetchUserProfile(user.uid)
      );
    }
  }, [user?.uid, dispatch]);

  const displayName =
    profile?.displayName ||
    profile?.firstName ||
    user?.displayName ||
    user?.email ||
    "User";

  const handleLogout = () => {
    dispatch(
      logout(navigate, toast)
    );
  };

  return (
    <Box
      as="nav"
      px={{ base: 4, md: 6 }}
      py={3}
      bg="white"
      borderBottomWidth="1px"
      borderBottomColor="gray.200"
      shadow="sm"
      color="gray.800"
      position="relative"
      zIndex={1000}
      aria-label="Main navigation"
    >
      <Flex
        justify="space-between"
        align={{
          base: "flex-start",
          md: "center",
        }}
        direction={{
          base: "column",
          md: "row",
        }}
        gap={4}
      >
        <Flex
          align="center"
          gap={3}
          flexWrap="wrap"
        >
          <RouterLink
            to="/projects"
            aria-label="Go to projects"
          >
            <Image
              src="/assets/logo.png"
              alt="Capital Project"
              width={{
                base: "160px",
                md: "200px",
              }}
              maxW="100%"
            />
          </RouterLink>

          <Button
            as={RouterLink}
            to="/projects"
            size="sm"
            variant="ghost"
            colorScheme="teal"
          >
            Projects
          </Button>

          <Button
            as={RouterLink}
            to="/projects/new"
            size="sm"
            colorScheme="purple"
          >
            New Project
          </Button>
          {isAdmin && (
  <Button
    as={RouterLink}
    to="/admin/users"
    size="sm"
    variant="outline"
    colorScheme="orange"
  >
    Account Requests
  </Button>
)}
        </Flex>

        <Flex
          align="center"
          gap={3}
          flexWrap="wrap"
        >
          <Text
            fontSize="sm"
            color="gray.600"
            maxW={{
              base: "100%",
              md: "260px",
            }}
            noOfLines={1}
            title={displayName}
          >
            Welcome, {displayName}
          </Text>

          <Button
            as={RouterLink}
            to="/account"
            size="sm"
            variant="outline"
            colorScheme="blue"
          >
            My Account
          </Button>

          <Button
            size="sm"
            colorScheme="gray"
            onClick={handleLogout}
            isLoading={loading}
            loadingText="Signing Out"
          >
            Sign Out
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Navbar;